"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkCellRenderer = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
require("@veeam/components/lib/Grid/types");
const constants_1 = require("../../../constants");
require("../../../core");
const Layouts_1 = require("../Layouts");
require("../types");
function linkCellRenderer({ action, icon, tooltipText, justify, }) {
    return function cellRenderer(_a) {
        var { cellData, rowData, disabled } = _a, otherProps = __rest(_a, ["cellData", "rowData", "disabled"]);
        if (!cellData) {
            return react_1.default.createElement(react_1.default.Fragment, null, constants_1.EMPTY_TEXT.dash);
        }
        return (react_1.default.createElement(Layouts_1.TruncatedText, { justify: justify },
            icon && !tooltipText && (react_1.default.createElement(Layouts_1.TooltipIconWrapper, null,
                react_1.default.createElement(Layouts_1.CellIcon, { "data-selector-id": "link-cell-icon", src: icon, disabled: disabled }))),
            icon && !!tooltipText && (react_1.default.createElement(components_1.Tooltip, { text: tooltipText, render: (_a) => {
                    var { ref } = _a, control = __rest(_a, ["ref"]);
                    return (react_1.default.createElement(Layouts_1.TooltipIconWrapper, null,
                        react_1.default.createElement(Layouts_1.CellIcon, Object.assign({}, control, { "data-selector-id": "link-cell-icon", src: icon, disabled: disabled }))));
                } })),
            react_1.default.createElement(Layouts_1.TooltipTextWrapper, { withIcon: !!icon }, !disabled ? (react_1.default.createElement(components_1.Link, { "data-selector-id": "link-cell", onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    action({ rowData });
                } },
                react_1.default.createElement(Layouts_1.LinkTextWrapper, null, components_1.textCellRenderer(Object.assign({ cellData, rowData }, otherProps))))) : (components_1.textCellRenderer(Object.assign({ cellData, disabled, rowData }, otherProps))))));
    };
}
exports.linkCellRenderer = linkCellRenderer;
//# sourceMappingURL=linkCellRenderer.js.map